import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CreditCard } from 'src/app/domain/credit-card';
import { Pagination } from 'src/app/domain/pagination';
import { CreditCardDTO } from 'src/app/domain/dto/credit-card.dto';

@Injectable({
  providedIn: 'root',
})
export class CreditCardService {
  url: string = `${environment.BASE_URL}/credit-cards`;
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  });

  constructor(private http: HttpClient) {}

  getAllActiveCreditCards() {
    return this.http.get<Array<CreditCard>>(`${this.url}/all-active`, {
      responseType: 'json',
    });
  }

  getCreditCards(creditCard: CreditCard, pagination: Pagination) {
    const params = {
      page: `${pagination.page ?? 1}`,
      per_page: `${pagination.per_page ?? 10}`,
      number: `${creditCard.number ?? ''}`,
      flag: `${creditCard.flag ?? ''}`,
      active: `${creditCard.active ?? ''}`,
    };

    return this.http.get(this.url, { responseType: 'json', params: params });
  }

  getCreditCard(id: number) {
    return this.http.get<CreditCard>(`${this.url}/${id}`, {
      responseType: 'json',
    });
  }
  save(creditCard: CreditCard) {
    let dto = new CreditCardDTO(creditCard);

    return this.http.post(`${this.url}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  update(creditCard: CreditCard) {
    let dto = new CreditCardDTO(creditCard);
    console.log(JSON.stringify(dto));
    return this.http.put(`${this.url}/${creditCard.id}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  delete(id: number) {
    return this.http.delete(`${this.url}/${id}`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  active(id: number) {
    return this.http.put(`${this.url}/${id}/active`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  deactive(id: number) {
    return this.http.put(`${this.url}/${id}/deactivate`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
}
